module.exports = __webpack_public_path__ + "img/brand-popular-models-ford.d42d98f5.png";